import { render, staticRenderFns } from "./SettingsNewAddressbook.vue?vue&type=template&id=2ae3ea54&"
import script from "./SettingsNewAddressbook.vue?vue&type=script&lang=js&"
export * from "./SettingsNewAddressbook.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports